/* Click color change image product */
jQuery(document).ready(function($) {
  jQuery('.engoj_select_color a').each(function(){
    jQuery(this).on("click",function(){
      var engoImage = jQuery(this).data('engojvariant-img');
      jQuery(this).parents('.engoj_grid_parent').find('.engoj_find_img img').attr({ src: engoImage }); 
      return false;
    });
  });
  
  $('.custom_quantity_cartpage .js-qty__adjust').on('click', function() {
    $(this).closest('form').submit();
  });
});

jQuery(document).ready(function($) {
  "use strict";


  function sizeGuide(){
    $('.btn_size_guide').on('click',function(){
      $('.content_size_guide').addClass('active');
      $('.js_sticky').removeClass('sticky_content');
      $('.overlay').addClass('active');
    });
    $('.overlay').on('click',function(){
      $('.content_size_guide').removeClass('active');
      $('.overlay').removeClass('active');
    });
    $('.close_size_guide').on('click',function(){
      $('.js_sticky').addClass('sticky_content');
      $('.content_size_guide').removeClass('active');
      $('.overlay').removeClass('active');
    });
  }

  function sortLayout() {
    if ($(window).width() < 1300) {
      $('.size_3').addClass('active');
      $('.size_4').removeClass('active');
      $('.size_5').addClass('d-none');
      $('.size_6').addClass('d-none');
    }

    if ($(window).width() >= 1300) {
      $('.size_3').removeClass('active');
      $('.size_4').addClass('active');
      $('.size_5').removeClass('d-none');
      $('.size_6').removeClass('d-none');
    }

    if ($(window).width() < 768) {
      $('.size_2').addClass('active');
      $('.size_4').removeClass('active');
      $('.size_5').addClass('d-none');
      $('.size_6').addClass('d-none');
      $('.size_4').addClass('d-none');
      $('.size_3').addClass('d-none');
    }
    $(window).resize(function(){
      if ($(window).width() < 1300) {
        $('.size_3').addClass('active');
        $('.size_4').removeClass('active');
        $('.size_5').addClass('d-none');
        $('.size_6').addClass('d-none');
      }

      if ($(window).width() >= 1300) {
        $('.size_3').removeClass('active');
        $('.size_4').addClass('active');
        $('.size_5').removeClass('d-none');
        $('.size_6').removeClass('d-none');
      }

      if ($(window).width() < 768) {
        $('.size_2').addClass('active');
        $('.size_4').removeClass('active');
        $('.size_5').addClass('d-none');
        $('.size_6').addClass('d-none');
        $('.size_4').addClass('d-none');
        $('.size_3').addClass('d-none');
      }
    });

    $('.size_6').on('click', function() {
      $('.js_size_prod').removeClass('col-lg-1 col-lg-3 col-lg-4 col-lg-5 col-lg-6 col-lg-7 col-lg-8 col-lg-9 col-lg-10 col-lg-11 col-lg-12 col-lg-2dot4 col-md-1 col-md-2 col-md-3 col-md-4 col-md-5 col-md-6 col-md-7 col-md-8 col-md-9 col-md-10 col-md-11 col-md-12');
      $('.js_size_prod').addClass(' col-lg-2');
      $(this).addClass('active');
      $('.size_5').removeClass('active');
      $('.size_4').removeClass('active');
      $('.size_3').removeClass('active');
    });	

    $('.size_5').on('click', function() {
      $('.js_size_prod').removeClass('col-lg-1 col-lg-2 col-lg-3 col-lg-4 col-lg-5 col-lg-6 col-lg-7 col-lg-8 col-lg-9 col-lg-10 col-lg-11 col-lg-12 col-lg-2dot4 col-md-1 col-md-2 col-md-3 col-md-4 col-md-5 col-md-6 col-md-7 col-md-8 col-md-9 col-md-10 col-md-11 col-md-12');
      $('.js_size_prod').addClass('col-lg-2dot4');
      $(this).addClass('active');
      $('.size_6').removeClass('active');
      $('.size_4').removeClass('active');
      $('.size_3').removeClass('active');
    });
    $('.size_4').on('click', function() {
      $('.js_size_prod').removeClass('col-lg-1 col-lg-2 col-lg-3 col-lg-4 col-lg-5 col-lg-6 col-lg-7 col-lg-8 col-lg-9 col-lg-10 col-lg-11 col-lg-12 col-lg-2dot4 col-md-1 col-md-2 col-md-3 col-md-4 col-md-5 col-md-6 col-md-7 col-md-8 col-md-9 col-md-10 col-md-11 col-md-12');
      $('.js_size_prod').addClass('col-md-3');
      $(this).addClass('active');
      $('.size_5').removeClass('active');
      $('.size_6').removeClass('active');
      $('.size_3').removeClass('active');
      $('.size_2').removeClass('active');
    });
    $('.size_3').on('click', function() {
      $('.js_size_prod').removeClass('col-lg-1 col-lg-2 col-lg-3 col-lg-4 col-lg-5 col-lg-6 col-lg-7 col-lg-8 col-lg-9 col-lg-10 col-lg-11 col-lg-12 col-lg-2dot4 col-md-1 col-md-2 col-md-3 col-md-4 col-md-5 col-md-6 col-md-7 col-md-8 col-md-9 col-md-10 col-md-11 col-md-12');
      $('.js_size_prod').addClass('col-md-4');
      $(this).addClass('active');
      $('.size_5').removeClass('active');
      $('.size_4').removeClass('active');
      $('.size_6').removeClass('active');
      $('.size_2').removeClass('active');
    });
    $('.size_2').on('click', function() {
      $('.js_size_prod').removeClass('col-lg-1 col-lg-2 col-lg-3 col-lg-4 col-lg-5 col-lg-6 col-lg-7 col-lg-8 col-lg-9 col-lg-10 col-lg-11 col-lg-12 col-lg-2dot4 col-md-1 col-md-2 col-md-3 col-md-4 col-md-5 col-md-6 col-md-7 col-md-8 col-md-9 col-md-10 col-md-11 col-md-12 col-12');
      $('.js_size_prod').addClass('col-6');
      $(this).addClass('active');
      $('.size_3').removeClass('active');
      $('.size_4').removeClass('active');
      $('.size_1').removeClass('active');
    });

    $('.size_1').on('click', function() {
      $('.js_size_prod').removeClass('col-lg-1 col-lg-2 col-lg-3 col-lg-4 col-lg-5 col-lg-6 col-lg-7 col-lg-8 col-lg-9 col-lg-10 col-lg-11 col-lg-12 col-lg-2dot4 col-md-1 col-md-2 col-md-3 col-md-4 col-md-5 col-md-6 col-md-7 col-md-8 col-md-9 col-md-10 col-md-11 col-md-12 col-6');
      $('.js_size_prod').addClass('col-12');
      $(this).addClass('active');
      $('.size_3').removeClass('active');
      $('.size_4').removeClass('active');
      $('.size_2').removeClass('active');
    });



  }

  function changeProdListGrid(){
    $('.prod_grid').on('click',function(){
      $('.product-grid-view').addClass('active');
      $('.product-list-view').removeClass('active');
      $(this).addClass('active');
      $('.prod_list').removeClass('active');
      $('.prod_per').removeClass('active');

    });
    $('.prod_list').on('click',function(){
      $('.product-grid-view').removeClass('active');
      $('.product-list-view').addClass('active');
      $(this).addClass('active');
      $('.prod_grid').removeClass('active');
      $('.prod_per').addClass('active');
    });
  }

  function FilterPushLeft(){
    $('.js_filter').on('click',function(){
      $('.filter-to-left').toggleClass('active');
      $('.overlay-filter').addClass('active');    
    });


    $('.close_filter').on('click',function(){
      $('.filter-to-left').removeClass('active');
      $('.overlay-filter').removeClass('active'); 
    });
    $('.overlay-filter').on('click',function(){
      $('.filter-to-left').removeClass('active');
      $('.overlay-filter').removeClass('active'); 
    });


  }

  function heighthdSticky(){

    $('.detail-info').css({'top':function(){
      return $('.js_height_hd').outerHeight() + 10;
    }})
  }

  

  // slideProductDetail();
  sizeGuide();
  // slideProductDetailBottom();
  sortLayout();
  changeProdListGrid();
  FilterPushLeft();
  // jsCollection();
  heighthdSticky();



});




jQuery(document).ready(function($) {
  "use strict";

  function promo(){
    $('.close_promo_topbar').on('click',function(){
      $('.promo_topbar').addClass("active");
    });
  }

  function search(){
    $('.js-search-destop').on('click', function() {
      $('.js-box-search').addClass('active');
      $('.bg_search_box').addClass('active');
      $('body').addClass('activedestop');
    });
    $('.js-drawer-close').on('click', function() {
      $('.js-box-search').removeClass('active');
      $('.bg_search_box').removeClass('active');
      $('body').removeClass('activedestop');
    });
    $('.bg_search_box').on('click', function() {
      $('.js-box-search').removeClass('active');
      $('.bg_search_box').removeClass('active');
      $('body').removeClass('activedestop');
    });
  }

  function minicart(){
    $('.js-call-minicart').on('click', function() {
      if ($('body').hasClass('first-time')) {
        if ($('.js_tbn_deal_coin').length) {
          $('.js_tbn_deal_coin')[0].dispatchEvent(new Event('click'));
        } else {
          window.location.href = '/cart';
        }
      } else {
        if ($('.box_contentmenu').hasClass('active')) {
          $('.menuclose').trigger('click');
        }
        $('.js-minicart').addClass('active');
        $('.bg-minicart').addClass('active');
        $('.contentbody').addClass('activecart');
        $('body').addClass('cartover');
        $('#smile-ui-container').hide();
        $('.whsec.deskicon').hide();
        $('.whsec.mblicon').hide();
        $('#giftbox-root').hide();
        $('.sticky-addtocart').addClass('hide');
      }
    });
    $('.close-mini-cart').on('click', function() {
      $('.js-minicart').removeClass('active');
      $('.bg-minicart').removeClass('active');
      $('.contentbody').removeClass('activecart');
      $('body').removeClass('cartover');
      $('#smile-ui-container').show();
      $('.whsec.deskicon').show();
	  $('.whsec.mblicon').show();
      $('#giftbox-root').show();
      $('.sticky-addtocart').removeClass('hide');

    });
    $('.bg-minicart').on('click', function() {
      $('.js-minicart').removeClass('active');
      $('.bg-minicart').removeClass('active');
      $('.contentbody').removeClass('activecart');
      $('body').removeClass('cartover');
      $('#smile-ui-container').show();
      $('.whsec.deskicon').show();
      $('.whsec.mblicon').show();		
      $('#giftbox-root').show();
    });

  }

  function menudestopscroll1() {
    var $nav = $(".jsheader1");
    $nav.removeClass('menu_scroll_v1');

    $(document).scroll(function() {

      $nav.toggleClass('menu_scroll_v1', $(this).scrollTop() > $nav.height());
    });
  }  

  function menudestopscroll2() {
    var $nav = $(".jsheader2");
    $nav.removeClass('menu_scroll_v2');

    $(document).scroll(function() {

      $nav.toggleClass('menu_scroll_v2', $(this).scrollTop() > $nav.height());
    });
  }

  function menudestopscroll3() {
    var $nav = $(".jsheader3");
    $nav.removeClass('menu_scroll_v3');

    $(document).scroll(function() {

      $nav.toggleClass('menu_scroll_v3', $(this).scrollTop() > $nav.height());
    });
  }

  function menudestopscroll4() {
    var $nav = $(".jsheader4");
    $nav.removeClass('menu_scroll_v4');

    $(document).scroll(function() {

      $nav.toggleClass('menu_scroll_v4', $(this).scrollTop() > $nav.height());
    });
  }

  function menudestopscroll6() {
    var $nav = $(".jsheader6");
    $nav.removeClass('menu_scroll_v6');

    $(document).scroll(function() {

      $nav.toggleClass('menu_scroll_v6', $(this).scrollTop() > $nav.height());
    });
  }

  function menuhorizon() {

    $('.js-model_menu').on('click', function() {
      $('.js-horizon-menu').addClass('active');
      $('.js-bg-horizon-menu').addClass('active');
      $('body').addClass('cartover');
    });

    $('.js_close-menu-horizon').on('click', function() {
      $('.js-horizon-menu').removeClass('active');
      $('.js-bg-horizon-menu').removeClass('active');
      $('body').removeClass('cartover');
    });

    $('.js-bg-horizon-menu').on('click', function() {
      $('.js-horizon-menu').removeClass('active');
      $('.js-bg-horizon-menu').removeClass('active');
      $('body').removeClass('cartover');
    });

  }

  function jsmenuiconh(){
    /*$('.js_icon_horizon-menu').on( 'click', function() {
      $(this).toggleClass('active');
    });*/
    $('.menu-horizon-list.parent > a').on('click', function(e){
      e.preventDefault();
      $(this).siblings('.submenu').addClass('sub-open');
    });
    $('.menu-horizon-list .go-back').on('click', function(){
      $(this).parent().removeClass('sub-open');
    });
    $('.menu-horizon-list .main-back').on('click', function(){
      $(this).parents().find('.submenu.sub-open').removeClass('sub-open');
    });
  }

  function jscalllogindestop(){
    $('.js-call-popup-login').on( 'click', function() {
      $('.js-poup-login-destop').addClass('active');
      $('.js-bg-login-popup').addClass('active');
    });
    $('.js-eveland-close-login').on( 'click', function() {
      $('.js-poup-login-destop').removeClass('active');
      $('.js-bg-login-popup').removeClass('active');
    });
    $('.js-bg-login-popup').on( 'click', function() {
      $('.js-poup-login-destop').removeClass('active');
      $('.js-bg-login-popup').removeClass('active');
    });
  }

  function jsBackLogin(){
    $('.jsCreate_account').on('click', function() {
      $('.form_register').show();
      $('.formlogin').hide();    
    });
    $('.tab_navar_right').on('click', function() {
      $('.formlogin').show();
      $('.form_register').hide();    
    });

    $('.jsBack_login').on('click', function() {
      $('.formlogin').show();
      $('.form_register').hide();        
    });
    $('.jsacount_destop').on('click', function() {
      $('.formlogin').show();
      $('.form_register').hide();        
    });
  }



  function jslogindestop(){
    $('.jsCreate_account').on('click', function() {
      $('.form_register-destop').show();
      $('.formlogin-destop').hide();    
    });
    $('.js-call-popup-login').on('click', function() {
      $('.formlogin-destop').show();
      $('.form_register-destop').hide();    
    });

    $('.jsBack_login').on('click', function() {
      $('.formlogin-destop').show();
      $('.form_register-destop').hide();        
    });
    $('.jsacount_destop').on('click', function() {
      $('.formlogin-destop').show();
      $('.form_register-destop').hide();        
    });
  }




  function mobilescroll() {
    var $nav = $(".jsmenumobile");
    $nav.removeClass('menu_mobilescroll');

    $(document).scroll(function() {

      $nav.toggleClass('menu_mobilescroll', $(this).scrollTop() > $nav.height());
    });
  }
if($(window).width() < 769){
  $('.product-hideft').addClass('hide');
}
  function menumobile() {
    $('.menuleft').on('click', function() {
      $(this).toggleClass('active');
      $('.box_contentmenu').toggleClass('active');     
      $('.box_contentmenu_background').toggleClass('active');
      $('body').toggleClass('menuactive');
      $('#smile-ui-container').addClass('hide');
      $('.whsec').addClass('hide');
    });
    /*$('.box_contentmenu_background').on('click', function() {
      $(this).removeClass('active');
      $('.box_contentmenu').removeClass('active');
      $('.menuleft').removeClass('active');
      $('.box_contentmenu_background').removeClass('active');
    });
    $('.js-eveland-close').on('click', function() {
      $(this).removeClass('active');
      $('.box_contentmenu').removeClass('active');
      $('.menuleft').removeClass('active');
      $('.box_contentmenu_background').removeClass('active');
    });*/
    $('.menuclose').on('click', function() {
      $('body').removeClass('menuactive');
      if ($('.contentbody').hasClass('activecart')) {
        $('.close-mini-cart').trigger('click');
      }
	  $('.tab_content_menu_mobile .submenu.sub-open').removeClass('sub-open');
      $(this).removeClass('active');
      $('.box_contentmenu').removeClass('active');
      $('.menuleft').removeClass('active');
      $('.box_contentmenu_background').removeClass('active');
      $('#smile-ui-container').removeClass('hide');
      $('.whsec').removeClass('hide');
    });
    $(window).resize(function(){
      if ($('.box_contentmenu').hasClass('active') && $(window).width() > 1199) {
        $('.menuclose').trigger('click');
      }
      if($(window).width() < 769){
        $('.product-hideft').addClass('hide');
      } else if ($(window).width() > 768){
        $('.product-hideft').removeClass('hide');
      }
    });
  }


  function popup(){
    $('.jsclosepoup').on('click', function() {
      $('.jsengo_popup').addClass('d-none');

    });
    $('.js-bg-overlay').on('click', function() {
      $('.jsengo_popup').addClass('d-none');

    });
  }
  function cookiepopup(){
    /*if (!jQuery.cookie('brilliant_pop_newletter') || jQuery.cookie('brilliant_pop_newletter') == null) {    
      jQuery(window).load(function() {
        setTimeout($('.jsengo_popup').show(), 300 * 1000);
        jQuery('.jsclosepoup').click(function(e) {
          e.preventDefault();
          jQuery('.jsengo_popup').hide(); 
          jQuery.cookie('brilliant_pop_newletter', '1', {expires: 1, path:'/', domain: '' });
                                                        });
        });
      } else {
		$('.jsengo_popup').remove();
    }*/
  }


  // Scroll to TOP
  function totop(){
    var back_to_top = $('#back-to-top');
    if (back_to_top.length) {
      var scrollTrigger = 100, // px
          backToTop = function() {
            var scrollTop = $(window).scrollTop();
            if (scrollTop > scrollTrigger) {
              back_to_top.addClass('show');
            } else {
              back_to_top.removeClass('show');
            }
          };
      $(window).on('scroll', function() {
        backToTop();
      });
      back_to_top.on('click', function(e) {
        e.preventDefault();
        $('html,body').animate({
          scrollTop: 0
        }, 700);
      });
    }
  }

 
  
  

  totop();
  jslogindestop();
  jscalllogindestop();
  popup();
  cookiepopup();
  menumobile();
  jsBackLogin();
  mobilescroll();

  jsmenuiconh();
  menuhorizon();

  
  menudestopscroll1();
  

  
  menudestopscroll2();
  

  
  menudestopscroll3();
  

  
  menudestopscroll4();
  

  
  menudestopscroll6();
  

  minicart();
  search();
  //   promo();
  //slidekeyactive();
});

/* Added by Developer to resolved reset password issue */
jQuery(document).ready(function(){
  var $formState = $('.reset-password-success');

  // check if reset password form was successfully submited.
  if (!$formState.length) {
    return;
  }

  // show success message
  $('#ResetSuccess').removeClass('hide').focus();
});

if ($('.product-single__form .add-buy .btn-action').length) {
  /*var elementTop = $('.product-single__form .add-buy .btn-action').offset().top;
  var elementHeight = $('.product-single__form .add-buy .btn-action').outerHeight();
  var elementBottom = elementTop + elementHeight;
  var addedHtml = '<div class="added-info" style="display:none;"><span><i class="fa fa-check"></i> Added to cart</span><a href="#" id="view-cart">View Cart</a></div>';
  $('.product-single__form .add-buy .btn-action').append(addedHtml);
  setTimeout(function(){
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    if (!(elementBottom > viewportTop && elementTop < viewportBottom)) {
        $('body').addClass('sticky-atc');
    } else {
        //$('body').removeClass('sticky-atc');
    }
  }, 500);
  $(window).on('resize scroll', function() {
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
      if (!(elementBottom > viewportTop && elementTop < viewportBottom)) {
          $('body').addClass('sticky-atc');
      } else {
          //$('body').removeClass('sticky-atc');
      }
  });*/

  $(window).on('resize scroll', function() {
      var elementTop = $('.product-single__form .add-buy .btn-action').offset().top;
      var elementHeight = $('.product-single__form .add-buy .btn-action').outerHeight();
      var elementBottom = elementTop + elementHeight;
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
      if (viewportTop > elementTop) {
          $('body').addClass('show-sticky-atc');
      } else {
          $('body').removeClass('show-sticky-atc');
      }
  });

  $('.added-info #view-cart').on('click', function(e) {
    e.preventDefault();
    $('.js-call-minicart').trigger('click');
  });

  $(document).on('click', '.sticky-addtocart .engoj-btn-addtocart-sticky', function() {
    $('.engoj-btn-addtocart').trigger('click');
  });
}

$('.section-product-v7 .swiper').each(function () {
  var swiperElem = document.getElementById($(this).attr('id'));
  var newSwiper = new MySwiper(swiperElem, {
    slidesPerView: 4,
    loop: false,
    speed: 1000,
    spaceBetween: 50,
    /*autoplay: {
      delay: 2500,
    },*/
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      360: {
        slidesPerView: 1.4,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 40,
      }
    }
  });
});

var productMediaGallerySwiperInit =  false;
function initProductGallerySwiper() {
  if (!$('.product-media-gallery').length) return;
  $('.product-media-gallery .swiper-remove').addClass('swiper');
  $('.product-media-gallery .swiper-wrapper-remove').addClass('swiper-wrapper');
  $('.product-media-gallery .swiper-slide-remove').addClass('swiper-slide');
  $('.product-media-gallery .swiper-pagination').removeClass('hide');
  var mediagallery = new MySwiper('.product-media-gallery .swiper', {
    slidesPerView: 1,
    direction: 'vertical',
    loop: true,
    speed: 1000,
    spaceBetween: 0,
    pagination: {
      el: ".product-media-gallery .swiper-pagination",
      clickable: true
    },
    on: {
      init: function (swiper) {
        if ($('.product-media-gallery .swiper-pagination-bullets').length) {
          $('.product-media-gallery .swiper-pagination-bullets')[0].style.setProperty('--top', ((20 * swiper.realIndex) + swiper.realIndex - 10) + 'px');
        }
      },
      slideChange: function (swiper) {
        if ($('.product-media-gallery .swiper-pagination-bullets').length) {
          $('.product-media-gallery .swiper-pagination-bullets')[0].style.setProperty('--top', ((20 * swiper.realIndex) + swiper.realIndex - 10) + 'px');
        }
      } 
    }
  });
  productMediaGallerySwiperInit =  true;
}

function destroyProductGallerySwiper() {
  if (!$('.product-media-gallery').length) return;
  var swiperInstance = $('.product-media-gallery .swiper')[0].swiper;
  swiperInstance.destroy( true, true );
  $('.product-media-gallery .swiper-remove').removeClass('swiper');
  $('.product-media-gallery .swiper-wrapper-remove').removeClass('swiper-wrapper');
  $('.product-media-gallery .swiper-slide-remove').removeClass('swiper-slide');
  $('.product-media-gallery .swiper-pagination').addClass('hide');
  productMediaGallerySwiperInit =  false;
}

if ($(window).width() < 767) {
  if (!productMediaGallerySwiperInit) {
    initProductGallerySwiper();
  }
}

$(window).resize(function() {
  if ($(window).width() > 767) {
    if (productMediaGallerySwiperInit) {
      destroyProductGallerySwiper();
    }
  } else {
    if (!productMediaGallerySwiperInit) {
      initProductGallerySwiper();
    }
  }
});

$(window).on('scroll', function() {
  document.querySelectorAll('[data-section-type="section-banner-video"]').forEach(function (videoSection) {
    var videoElem = videoSection.querySelector('.video-youtube') || videoSection.querySelector('.video-vimeo') || videoSection.querySelector('.video-html') || false;
    if (videoElem) {
      var video_top_pos = $(videoElem).offset().top;
      var video_bottom_pos = $(videoElem).offset().top + $(videoElem).outerHeight();
      if ($(window).scrollTop() + ($(window).innerHeight() / 2) >= video_top_pos && $(window).scrollTop() + ($(window).innerHeight() / 2) < video_bottom_pos) {
        if (videoElem.classList.contains('video-youtube')) {
          videoElem.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
        } else if (videoElem.classList.contains('video-vimeo')) {
          videoElem.contentWindow.postMessage('{"method":"play"}', '*');
        } else if (videoElem.classList.contains('video-html')) {
          videoElem.play();
        } else {
        }
      } else {
        if (videoElem.classList.contains('video-youtube')) {
          videoElem.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
        } else if (videoElem.classList.contains('video-vimeo')) {
          videoElem.contentWindow.postMessage('{"method":"pause"}', '*');
        } else if (videoElem.classList.contains('video-html')) {
          videoElem.pause();
        } else {
        }
      }
    }
  });
});

$('.qa-btn:not(.direct-add)').on('click', function() {
  $(this).addClass('active');
  $('body').addClass('has-prod-ingredients');
  $(this).next().addClass('active').appendTo($('body'));
  setTimeout(function(){
    $('body.has-prod-ingredients > .prod-ingrediants').addClass('animate');
  }, 10);
});

$('.qa-btn.direct-add').on('click', function() {
  $(this).addClass('active adding');
  $(this).siblings('.prod-ingrediants').find('.product-single__form').submit();
});

$('.prod-ing-close').on('click', function() {
  $('.prod-ingrediants.active').removeClass('animate');
  $('.prod-ingrediants.active .enj-add-to-cart-btn').html('<i>Add to cart</i>');
  setTimeout(function() {
    $('body').removeClass('has-prod-ingredients');
    $('.qa-btn.active').after($('.prod-ingrediants.active'));
    $('.prod-ingrediants.active').removeClass('active');
    $('.qa-btn.active').removeClass('active');
  }, 250);
  setTimeout(function() {
    $('.qa-btn.added').text('+').removeClass('added');
  }, 5000);
});
$('.tab-switcher').on('change', function() {
  var selectedtab = $(this).val();
  $(selectedtab).siblings().fadeOut();
  $(selectedtab).fadeIn();
});



const handleIntersectionReview = (entries, observer) => {
  if (!entries[0].isIntersecting) return;
  observer.unobserve(document.querySelector('[data-stamped-review]'));

  const pros = document.querySelector('[data-stamped-review]').dataset.products;
  const prosArr = pros.split(',');
  var prosQuery = [];
  prosArr.forEach(function(val){
    prosQuery.push('productIds[]=' + val);
  });
  $(document).on('click', '.review-info .readMore', function() {
    $(this).parent().siblings('.fullmessage').show();
    $(this).parent().hide();
  });
  $(document).on('click', '.review-info .readLess', function() {
    $(this).parent().siblings('.truncated').show();
    $(this).parent().hide();
  });
  fetch(`https://stamped.io/api/widget/reviews?${prosQuery.join('&')}&minRating=5&take=30&apiKey=pubkey-N6ama76O6k00gHMM50m0U9bKANYuSl&storeUrl=brillare-root-deep.myshopify.com`)
  .then(function(response) {
      return response.json();
  }).then(function(response) {
      const reviewTemplate = document.querySelector('script#review-template');
      const text = reviewTemplate.innerHTML;
      const template = Handlebars.compile(text);
      const reviewDataWithSummary = response.data.map(function(review) {
        return ({
          ...review,
          'truncated': review.reviewMessage.length > 50 ? review.reviewMessage.substring(0, 50) + '...<span class="readMore">[+]</span>' : review.reviewMessage
        });
      });
      console.log(reviewDataWithSummary);
      const reviewData = template({
        items: reviewDataWithSummary,
        totalCount: response.totalAll
      });
      document.querySelector('[data-stamped-review]').innerHTML = reviewData;
    
  }).catch(e => {
    console.error(e);
  });
}

var stampedReviewSelector = document.querySelector('[data-stamped-review]') || false;
if (stampedReviewSelector) {
  new IntersectionObserver(handleIntersectionReview, {rootMargin: '0px 0px 300px 0px'}).observe(document.querySelector('[data-stamped-review]'));
}

$('.section-key-active .field__p-key-title').on('click', function() {
  $(this).toggleClass('active')
  $(this).next().stop(true,true).slideToggle(600);  
});

$('[data-action="view-all-collections"]').on('click', function (e) {
  e.preventDefault();
  if($(this).parent().prev('.col-items').hasClass("view-all")) {
    $(this).parent().prev('.col-items').removeClass('view-all');
    $(this).text("View More");
  }else{
    $(this).parent().prev('.col-items').addClass('view-all');
    $(this).text("View Less");
  }
});

$('.product-media-gallery.desktop [data-src-master]').each(function() {
  $(this).parent().zoom({
    url: $(this).attr('data-src-master')
  });
});

var scrollTriggerInited = false;
if (window.initgsap && $('.section-how-to-uses').length) {
  gsap.registerPlugin(ScrollTrigger);
  function initScrollTrigger() {
    var sections = gsap.utils.toArray(".step-video-box");
    let maxWidth = 0;

    var getMaxWidth = () => {
      maxWidth = 0;
      sections.forEach((section) => {
        maxWidth += section.offsetWidth;
      });
    };
    getMaxWidth();
    ScrollTrigger.addEventListener("refreshInit", getMaxWidth);

   let scrollTween = gsap.to(sections, {
      x: () => `-${maxWidth - window.innerWidth}`,
      ease: "none",
      scrollTrigger: {
        trigger: ".step-video-box-wrapper",
        pin: true,
        scrub: true,
        end: () => `+=${maxWidth}`,
        invalidateOnRefresh: true
      }
    });

    sections.forEach((sct, i) => {
      ScrollTrigger.create({
        trigger: sct,
        start: () => 'top top-=' + (sct.offsetLeft - window.innerWidth/2) * (maxWidth / (maxWidth - window.innerWidth)),
        end: () => '+=' + sct.offsetWidth * (maxWidth / (maxWidth - window.innerWidth)),
        containerAnimation: scrollTween,
        toggleClass: "active",
        onToggle: function (self) {
          var videoElemProduct = self.trigger.querySelector('iframe') || self.trigger.querySelector('video') || false;
          if (videoElemProduct) {
            if (videoElemProduct.nodeName == 'VIDEO') {
              if(!self.isActive){
                videoElemProduct.pause();
              }
              if (self.isActive) {
                videoElemProduct.play();
              }
            } else {
              if (videoElemProduct.src.indexOf('youtube') !== -1) {
                if(!self.isActive){
                  videoElemProduct.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
                }
                if (self.isActive) {
                  videoElemProduct.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
                } 
              }
              if (videoElemProduct.src.indexOf('vimeo') !== -1) {
                if(!self.isActive){
                  videoElemProduct.contentWindow.postMessage('{"method":"pause"}', '*');
                }
                if (self.isActive) {
                  videoElemProduct.contentWindow.postMessage('{"method":"play"}', '*');
                } 
              }
            }
          }
        },
        toggleClass: {targets: sct, className: "active"}
      });
    });
    scrollTriggerInited = true;
  }

  function destroyScrollTrigger() {
    let triggers = ScrollTrigger.getAll();
    triggers.forEach( trigger => {      
      trigger.kill();
    });
    scrollTriggerInited = false;
  }

  $(window).on('scroll', function() {
    if ($(window).width() < 1200) {
      document.querySelectorAll('[data-step-video-box]').forEach(function (videoSection) {
        var videoElemScroll = videoSection.querySelector('iframe') || videoSection.querySelector('video') || false;
        if (videoElemScroll) {
          var video_top_pos = $(videoElemScroll).offset().top;
          var video_bottom_pos = $(videoElemScroll).offset().top + $(videoElemScroll).outerHeight();
          if ($(window).scrollTop() + ($(window).innerHeight() / 2) >= video_top_pos && $(window).scrollTop() + ($(window).innerHeight() / 2) < video_bottom_pos) {
            if (videoElemScroll.nodeName == 'VIDEO') {
              videoElemScroll.play();
            } else {
              if (videoElemScroll.src.indexOf('youtube') !== -1) {
                  videoElemProduct.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
              }
              if (videoElemScroll.src.indexOf('vimeo') !== -1) {
                  videoElemScroll.contentWindow.postMessage('{"method":"play"}', '*');
              }
            }
          } else {
            if (videoElemScroll.nodeName == 'VIDEO') {
              videoElemScroll.pause();
            } else {
              if (videoElemScroll.src.indexOf('youtube') !== -1) {
                  videoElemScroll.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
              }
              if (videoElemScroll.src.indexOf('vimeo') !== -1) {
                videoElemScroll.contentWindow.postMessage('{"method":"pause"}', '*');
              }
            }
          }
        }
      });
    }
  });

  window.addEventListener("load", (event) => {
     $(window).resize(function() {
      if($(window).width() < 1200) {
        if (scrollTriggerInited) {
          destroyScrollTrigger();
        }
      } else {
        if (!scrollTriggerInited) {
          initScrollTrigger();
        }
      }
    });

    if($(window).width() >= 1200) {
      setTimeout(function() {
        if (!scrollTriggerInited) {
          initScrollTrigger();
        }
      }, 500);
    }
  });
    
  // $(window).load(function() {
  //   $(window).resize(function() {
  //     if($(window).width() < 1200) {
  //       if (scrollTriggerInited) {
  //         destroyScrollTrigger();
  //       }
  //     } else {
  //       if (!scrollTriggerInited) {
  //         initScrollTrigger();
  //       }
  //     }
  //   });

  //   if($(window).width() >= 1200) {
  //     setTimeout(function() {
  //       if (!scrollTriggerInited) {
  //         initScrollTrigger();
  //       }
  //     }, 500);
  //   }
  // });
}


$('.product-qa-btn').on('click',function() {
  if ($('.product-single__form .enj-add-to-cart-btn').length) {
    $(this).addClass('clicked');
    $('.product-single__form .enj-add-to-cart-btn').trigger('click');
  }
});

/*if ($('.counter').length) {
    $( '.counter' ).each( function() {
        $( this ).appear().trigger( 'resize' );
    });
    $(document).on('appear', '.counter', function (e) {
        var _this = $(this);
        if (!_this.hasClass('appear')) {
            var options = _this.data('countToOptions') || {};
            options['onComplete'] = function() {
              if (_this.text() != _this.attr('data-to') && _this.attr('data-to') > _this.text()) {
                _this.text(_this.attr('data-to'));
              }
            }
            _this.countTo(options);
            _this.addClass('appear');
        }
    });
}*/

if ($('.product-ingrediants .total-ingredients:not(.popup-ing) span').length) {
    $('.product-ingrediants .total-ingredients:not(.popup-ing) span').attr('data-speed', '1500');
    $('.product-ingrediants .total-ingredients:not(.popup-ing) span').attr('data-to', $('.product-ingrediants .total-ingredients:not(.popup-ing) span').text().replace('%', ''));
    $( '.product-ingrediants .total-ingredients:not(.popup-ing) span' ).each( function() {
        $( this ).appear().trigger( 'resize' );
    });
    $(document).on('appear', '.product-ingrediants .total-ingredients:not(.popup-ing) span', function (e) {
        var _this = $(this);
        if (!_this.hasClass('appear')) {
            var options = _this.data('countToOptions') || {};
            options['onComplete'] = function() {
              if (_this.text() != _this.attr('data-to') && _this.attr('data-to') > _this.text()) {
                _this.text(_this.attr('data-to'));
              }
            }
            _this.countTo(options);
            _this.addClass('appear');
        }
    });
}




var ls = 0;
$(window).scroll(function() {
  var st = $(window).scrollTop();
  var wh_half = $(window).outerHeight() / 2;
  var nums = [];
  $('.engoj_img_main-wrapper').each(function(index, item){
    var iot = $(this).offset().top;
    var ioB = iot + $(this).outerHeight();
    if (st > (iot - wh_half) && st < (ioB + wh_half) ) {
      nums.push(index);
    }
  });
  if (st < ls) {
    if (nums.length) {
      var activeIndex = nums[nums.length - 1];
      $('.product-media-gallery-dots')[0].style.setProperty('--top', ((20 * activeIndex) + activeIndex - 10) + 'px');
      $('.product-media-gallery-dots span:eq('+nums[nums.length - 1]+')').addClass('active');
      $('.product-media-gallery-dots span:eq('+nums[nums.length - 1]+')').nextAll().removeClass('active');
      $('.product-media-gallery-dots span:eq('+nums[nums.length - 1]+')').prevAll().removeClass('active');
    }
  } else {
    if (nums.length) {
      var activeIndex = nums[nums.length - 1];
      $('.product-media-gallery-dots')[0].style.setProperty('--top', ((20 * activeIndex) + activeIndex - 10) + 'px');
      $('.product-media-gallery-dots span:eq('+nums[nums.length - 1]+')').nextAll().removeClass('active');
      $('.product-media-gallery-dots span:eq('+nums[nums.length - 1]+')').prevAll().removeClass('active');
      $('.product-media-gallery-dots span:eq('+nums[nums.length - 1]+')').addClass('active');
    }
    //fwd
  }
  ls = st;
});
